var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPillFilled = function SvgPillFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.233 10.233a12.117 12.117 0 0 1-4.183 2.759l-.517.2-1.275-1.275a5.383 5.383 0 0 1-1.591-3.834 5.35 5.35 0 0 1 1.591-3.825 5.412 5.412 0 0 1 7.659 0l1.275 1.275-.2.517a12.314 12.314 0 0 1-2.759 4.183Zm5.509-2.15L14.158 6.5h-.008a13.235 13.235 0 0 1-3.033 4.617 13.204 13.204 0 0 1-4.609 3.033H6.5l1.583 1.592a5.393 5.393 0 0 0 3.834 1.583 5.36 5.36 0 0 0 3.825-1.583 5.364 5.364 0 0 0 1.591-3.825 5.398 5.398 0 0 0-1.591-3.834Z",
    fill: "current"
  })));
};
export default SvgPillFilled;